import { Button, IconButton, SxProps } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
type ResponsiveButtonProps = {
  icon: React.ReactNode;
  to: string;
  variant?: string;
  children?: React.ReactNode;
  sx?: SxProps;
};

export const ResponsiveButtonLink: FC<ResponsiveButtonProps> = ({
  icon,
  to,
  children,
  variant = "contained",
  sx = {},
}) => {
  return (
    <>
      <Button
        variant={variant as any}
        color="primary"
        component={Link}
        to={to}
        startIcon={icon}
        sx={{ display: { xs: "none", sm: "flex" }, ...sx }}
      >
        {children}
      </Button>
      <IconButton
        color="primary"
        component={Link}
        to={to}
        sx={{
          display: { xs: "block", sm: "none" },
          bgcolor: "primary.main",
          color: "white",
          width: 40,
          height: 40,
          ":hover": { bgcolor: "primary.dark" },
          ...sx,
        }}
      >
        {icon}
      </IconButton>
    </>
  );
};
